import styled from 'styled-components'
import {
  SPACING,
  BORDER_RADIUS,
  TYPOGRAPHY,
  TRANSITIONS,
  FONT_WEIGHT,
} from '../../../../../styles/theme'

export const FooterContainer = styled.div<{ $borderColor: string }>`
  background-color: transparent;
  position: relative;
`

export const FooterHeader = styled.div<{ $clickable?: boolean }>`
  padding: 6px ${SPACING.md};
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.$clickable ? 'space-between' : 'flex-end')};
  cursor: ${(props) => (props.$clickable ? 'pointer' : 'default')};
  transition: ${TRANSITIONS.fast};
  min-height: 28px;
  background-color: transparent;
  border-top: 1px solid var(--color-border);

  ${(props) =>
    props.$clickable &&
    `
        &:hover {
            background-color: var(--color-overlay-light);
        }
    `}
`

export const ScoreLabel = styled.span`
  font-size: ${TYPOGRAPHY.caption.fontSize};
  font-weight: ${FONT_WEIGHT.medium};
  color: var(--color-text-primary);
`

export const ScoreValue = styled.span<{ $accentColor: string }>`
  font-size: ${TYPOGRAPHY.caption.fontSize};
  font-weight: ${FONT_WEIGHT.semibold};
  color: ${(props) => props.$accentColor};
  background-color: ${(props) => props.$accentColor}20;
  padding: 2px ${SPACING.sm};
  border-radius: ${BORDER_RADIUS.sm};
`

export const AccordionContent = styled.div<{ $isOpen: boolean }>`
  max-height: ${(props) => (props.$isOpen ? '1000px' : '0')};
  overflow: hidden;
  transition: max-height 0.3s ease;
`

export const RatingsList = styled.div`
  padding: ${SPACING.sm} ${SPACING.md};
  background-color: var(--color-bg-secondary);
`

export const RatingItem = styled.div`
  padding: ${SPACING.sm} 0;
  border-bottom: 1px solid var(--color-border);

  &:last-child {
    border-bottom: none;
  }
`

export const RatingHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${SPACING.xs};
`

export const RatingName = styled.span`
  font-size: ${TYPOGRAPHY.caption.fontSize};
  font-weight: ${FONT_WEIGHT.semibold};
  color: var(--color-text-primary);
`

export const RatingRole = styled.span`
  font-size: ${TYPOGRAPHY.caption.fontSize};
  color: var(--color-text-tertiary);
  font-style: italic;
`

export const RatingScore = styled.span<{ $accentColor: string }>`
  font-size: ${TYPOGRAPHY.caption.fontSize};
  font-weight: ${FONT_WEIGHT.semibold};
  color: ${(props) => props.$accentColor};
`

export const StructuredFeedback = styled.div`
  margin-top: ${SPACING.sm};
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const FeedbackSection = styled.div`
  font-size: ${TYPOGRAPHY.caption.fontSize};
  line-height: 1.4;
`

export const FeedbackLabel = styled.div`
  font-weight: ${FONT_WEIGHT.semibold};
  color: var(--color-text-secondary);
  margin-bottom: 3px;
  font-size: ${TYPOGRAPHY.caption.fontSize};
  text-transform: uppercase;
  letter-spacing: 0.3px;
`

export const FeedbackText = styled.div`
  color: var(--color-text-secondary);
  padding-left: 6px;
  border-left: 2px solid var(--color-border);
`

export const FeedbackRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${SPACING.sm};
`

export const FeedbackContent = styled.div`
  flex: 1;
  min-width: 0;
`

export const ChatButton = styled.button<{ $accentColor: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${SPACING.xs};
  background: transparent;
  border: 1px solid transparent;
  border-radius: ${BORDER_RADIUS.sm};
  cursor: pointer;
  opacity: 0.5;
  transition: ${TRANSITIONS.all};
  flex-shrink: 0;
  margin-top: 2px;

  &:hover {
    opacity: 1;
    background: ${(props) => props.$accentColor}15;
    border-color: ${(props) => props.$accentColor}40;
  }

  &:active {
    transform: scale(0.95);
  }
`

export const ActionGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`

export const HeaderFlexContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`
